// extracted by mini-css-extract-plugin
export default {"root":"MdRenderer_root__dwTqN","emoji-mart-emoji":"MdRenderer_emoji-mart-emoji__52HoT"};